import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TabViewCustom } from '../../../_models/tab-view-custom';
import { NavService } from '../../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FlujoVentaPasoControlService } from '../../../_services/flujo-venta-paso-control.service';
import { FlujoVentaPasoControl } from '../../../_models/flujo-venta-paso-control';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FlujoVentaPasoAdjunto } from '../../../_models/flujo-venta-paso-adjunto';
import { FlujoVentaPasoAdjuntoService } from '../../../_services/flujo-venta-paso-adjunto.service';
import { forkJoin, Subscription } from 'rxjs';
import { FlujoVentaPasoService } from '../../../_services/flujo-venta-paso.service';
import { FlujoVentaPasoVinculacionService } from '../../../_services/flujo-venta-paso-vinculacion.service';
import { FlujoVentaPasoVinculacion } from '../../../_models/flujo-venta-paso-vinculacion';
import { ListaService } from '../../../_services/lista.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AppSettings } from '../../../../proyect.conf';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { AdjuntoService } from '../../../_services/adjunto.service';
import { Table } from 'primeng/table';
import { ComunicationComponentsService } from '../../../_services/comunication-components.service';
import { FlujoVentaPaso } from '../../../_models/flujo-venta-paso';
import { Pasos } from '../../../_enums/enum';
import { scrollToFirstInvalidControl } from '../../../utils/utilidades';
import { RolFuncionalitiesServices } from '../../../_services/rol-funcionalidad.service';
import { RolFunctionalidadControl } from '../../../_models/rol-functionalidad-control';
import {FlujoVentaPasoTiposPersonas} from '../../../_models/flujo-venta-paso-tipos-personas';
import {FlujoVentaPasoTiposPersonasService} from '../../../_services/flujo-venta-paso-tipos-personas.service';
import {FlujoVentaPasoOcupacion} from '../../../_models/flujo-venta-paso-ocupacion';
import {FlujoVentaPasoOcupacionService} from '../../../_services/flujo-venta-paso-ocupacion.service';
import {TipoOcupacionConfiguracionService} from '../../../_services/tipo-ocupacion-configuracion.service';

@Component( {
  selector: 'app-flujo-venta-agregar-tabla',
  templateUrl: 'flujo-venta-agregar-tabla.component.html'
} )

export class FlujoVentaAgregarTablaComponent implements OnInit, OnDestroy {

  @Input() tabView: TabViewCustom;
  @Output() dismiss: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() lisSecuencia: SelectItem[] = [];
  @Input() secFija: boolean;
  @Input() lisPasos: FlujoVentaPaso[] = [];
  @Input() lisVinculacion: SelectItem[] = [];
  @Input() lisTipoPersonas: SelectItem[] = [];
  @Input() HabilitarindicadorVinculacionPorPerfil: boolean = false;
  lisFlujoVentaControl: FlujoVentaPasoControl[] = [];
  lisFlujoVentaControlTodos: FlujoVentaPasoControl[] = [];
  lisFlujoVentaPasoVinculacion: FlujoVentaPasoVinculacion[] = [];
  lisFlujoVentaPasoTiposPersonas: FlujoVentaPasoTiposPersonas[] = [];
  lisFlujoVentaPasoOcupaciones: FlujoVentaPasoOcupacion[] = [];
  listaTiposOcupacionesConfig: SelectItem[] = [];
  cargando = true;
  lisControl: SelectItem[] = [];
  submitted = false;
  formulario: FormGroup;
  fluVentaAdjunto: FlujoVentaPasoAdjunto;
  subControl: boolean;
  forControl: FormGroup;
  columnas: any[] = [];
  carImagen = false;
  imagen: SafeResourceUrl;
  svcThUrl = AppSettings.rutServiciosADJ + '/api/adjuntos';
  nomArchivo: string;
  @ViewChild('dt') tabla: Table;
  @ViewChild('flujoVentaForm') flujoVentaFormRef: ElementRef<HTMLFormElement>;
  busqueda: string;
  subscription: Subscription;
  adjTemporal: any;
  adjunto: any;
  pasosEnum = Pasos;
  carTabla: boolean;
  lisRoles: RolFunctionalidadControl[] = [];
  colRoles: any[] = [];
  objControlSeleccionado: FlujoVentaPasoControl;
  mosModalRoles = false;
  ListBitacora:  SelectItem[] = [];

  constructor( private navService: NavService,
               private fluVentaPasoControlService: FlujoVentaPasoControlService,
               private fb: FormBuilder,
               private fluVentaPasoService: FlujoVentaPasoService,
               private fluVentaPasoAdjuntoService: FlujoVentaPasoAdjuntoService,
               private lisService: ListaService,
               private adjService: AdjuntoService,
               private autServicio: AutenticacionService,
               private sanitizer: DomSanitizer,
               private fluVentaPasoVinculacionService: FlujoVentaPasoVinculacionService,
               private communicationService: ComunicationComponentsService,
               private rolFuncionalidadControlService: RolFuncionalitiesServices,
               private conService: ConfirmationService,
               private flujoVentaPasoTiposPersonas: FlujoVentaPasoTiposPersonasService,
               private flujoVentaPasoOcupacionService: FlujoVentaPasoOcupacionService,
               private tipoOcupacionConfiguracionService: TipoOcupacionConfiguracionService) {
  }

  ngOnInit(): void {
    this.tipoOcupacionConfiguracionService.listadoHabilitados().subscribe( tipos => {
      this.listaTiposOcupacionesConfig = tipos.map( t => ( { label: t.codigoTipoOcupacion + ' - ' + t.nombreTipoOcupacion, value: t.idTipoOcupacionConfiguracion } ) );
    } );

    this.columnas = [
      { field: 'codigoFuncionalidadControl', header: this.navService.buscarMensaje( 'FLUJOVENTA.LBL_CODIGO' ), sort: false },
      { field: 'funcionalidadControl', header: this.navService.buscarMensaje( 'FLUJOVENTA.LBL_NOMBRECAMPO' ), sort: false },
      { field: 'indicadorVisible', header: this.navService.buscarMensaje( 'FLUJOVENTA.LBL_VISIBLE' ), sort: false },
      { field: 'bitacora', header: this.navService.buscarMensaje( 'FLUJOVENTA.LBL_BITACORA' ), sort: false },
      { field: 'det', header: this.navService.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.colRoles = [
      { field: 'rol', header: this.navService.buscarMensaje( 'FLUJOVENTA.LBL_ROL' ), sort: false },
      { field: 'indicadorEditar', header: this.navService.buscarMensaje( 'FLUJOVENTA.LBL_EDITAR' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navService.buscarMensaje( 'FLUJOVENTA.LBL_VISUALIZAR' ), sort: false }
    ];

    if ( this.tabView.flujoVenta ) {
      forkJoin( this.fluVentaPasoControlService.listadoPorIdFlujoPaso( this.tabView.flujoVenta.idFlujoVentaPaso ),
        this.fluVentaPasoAdjuntoService.obtenerPorIdFlujoVentaPaso( this.tabView.flujoVenta.idFlujoVentaPaso ),
        this.fluVentaPasoVinculacionService.listadoPorIdFlujoPaso( this.tabView.flujoVenta.idFlujoVentaPaso ),
        this.flujoVentaPasoTiposPersonas.listadoPorIdFlujoPaso( this.tabView.flujoVenta.idFlujoVentaPaso ),
        this.flujoVentaPasoOcupacionService.listadoPorIdFlujoPaso( this.tabView.flujoVenta.idFlujoVentaPaso )
        ).subscribe( ( [ listado, adjunto, lisVinculacion, listaTipoPersona, listaOcupaciones ] ) => {
        this.lisFlujoVentaControlTodos = listado;
        this.fluVentaAdjunto = adjunto;
        this.lisFlujoVentaPasoVinculacion = lisVinculacion;
        this.lisFlujoVentaPasoTiposPersonas = listaTipoPersona;
        this.lisFlujoVentaPasoOcupaciones = listaOcupaciones;
        if ( this.fluVentaAdjunto && this.fluVentaAdjunto.indicadorHabilitado ) {
          this.cargarAdjunto( this.fluVentaAdjunto );
        }
        this.cargarListado();
        this.cargarComunes();
      } );
    } else {
      this.cargarComunes();
    }
  }

  cargarComunes() {
    this.cargarControles();
    this.cargarFormulario();
    this.cargarFormularioControl();
    this.conectarCanal();
    this.cargando = false;
  }

  conectarCanal() {
    if ( !this.secFija ) {
      this.subscription = this.communicationService.emisorComponent$.subscribe( r => {
        if ( r.canal === 'flujo-venta' && this.formulario && r.mensaje && !!r.mensaje.find( x => x === this.tabView.codigo ) ) {
          this.f.secuencia.setValue( this.tabView.flujoVenta ? this.tabView.flujoVenta.secuencia : null );
        }
      } );
    }
  }

  cargarListado() {
    this.lisFlujoVentaControl = [ ...this.lisFlujoVentaControlTodos.filter( x => x.indicadorHabilitado ) ];
  }

  cargarControles() {
    this.lisControl = [];
    this.tabView.controles.forEach( e => {
      if ( e.indicadorHabilitado && !this.lisFlujoVentaControl.find( x => x.idFuncionalidadControl === e.idFuncionalidadControl ) ) {
        this.lisControl.push( { label: `${ e.codigo } - ${ e.nombre }`, value: e.idFuncionalidadControl } );
      }
    } );
  }

  cargarFormulario() {
    const vinculaciones = [];
    this.lisFlujoVentaPasoVinculacion.forEach( e => {
      if ( e.indicadorHabilitado ) {
        vinculaciones.push( e.idTipoVinculacion );
      }
    } );
    const naturaleza = [];
    const ocupaciones = [];
    this.lisFlujoVentaPasoTiposPersonas.forEach( e => {
      if ( e.indicadorHabilitado ) {
        naturaleza.push( e.idTipoPersona );
      }
    } );
    this.lisFlujoVentaPasoOcupaciones.forEach( e => {
      if ( e.indicadorHabilitado ) {
        ocupaciones.push( e.idTipoOcupacionConfiguracion );
      }
    } );
    this.formulario = this.fb.group( {
      idFlujoVentaPaso: [ this.tabView.flujoVenta ? this.tabView.flujoVenta.idFlujoVentaPaso : null ],
      codigo: [ this.tabView.flujoVenta ? this.tabView.flujoVenta.codigo : this.tabView.codigo, [ Validators.required ] ],
      nombre: [ this.tabView.flujoVenta ? this.tabView.flujoVenta.nombre : null, [ Validators.required ] ],
      descripcion: [ this.tabView.flujoVenta ? this.tabView.flujoVenta.descripcion : null, [] ],
      vinculaciones: [ vinculaciones, [ Validators.required ] ],
      secuencia: [ this.tabView.flujoVenta ? this.tabView.flujoVenta.secuencia : ( this.secFija ? this.tabView.secuencia : null ), [ Validators.required ] ],
      idAdjunto: [ ( this.fluVentaAdjunto && this.fluVentaAdjunto.indicadorHabilitado ) ? this.fluVentaAdjunto.idAdjunto : null, [] ],
      indicadorHabilitado: [ this.tabView.flujoVenta ? this.tabView.flujoVenta.indicadorHabilitado : true ],
      indicadorPasoPrincipal: [ this.tabView.flujoVenta ? this.tabView.flujoVenta.indicadorPasoPrincipal : true ],
      indicadorGestorTerceros: [ this.tabView.flujoVenta ? this.tabView.flujoVenta.indicadorGestorTerceros : false ],
      indicadorVinculacionPerfil: [ this.tabView.flujoVenta ? this.tabView.flujoVenta.indicadorVinculacionPerfil : false ],
      indicadorPreaprobado: [ this.tabView.flujoVenta ? this.tabView.flujoVenta.indicadorPreaprobado : false ],
      indicadorOcupacion: [ this.tabView.flujoVenta ? this.tabView.flujoVenta.indicadorOcupacion : false ],
      idsOcupacion: [ ocupaciones, this.tabView.flujoVenta?.indicadorOcupacion ? [ Validators.required ] : [] ],
      idsNaturaleza: [ naturaleza, this.tabView.codigo !== this.pasosEnum.DATOSBASICOS && this.tabView.codigo !== this.pasosEnum.FINPROCESO ? [Validators.required] : [] ],
    } );

    this.formulario.get( 'indicadorOcupacion' ).valueChanges.subscribe( value => {
      const ctrl = this.formulario.get( 'idsOcupacion' );
      if ( value ) {
        ctrl.setValidators( [ Validators.required ] );
      } else {
        ctrl.clearValidators();
        ctrl.setValue( [] );
      }
      ctrl.updateValueAndValidity();
    } );

    if ( this.tabView.flujoVenta && this.tabView.flujoVenta.codigo === Pasos.DATOSBASICOS ) {
      this.f.indicadorPasoPrincipal.setValue( true );
    }


  }

  cargarFormularioControl() {
    this.forControl = this.fb.group( {
      idFuncionalidadControl: [ null, [ Validators.required ] ],
      indicadorBitacora: [false]
    } );
  }

  agregarControl() {
    this.subControl = true;
    if ( this.forControl.valid ) {
      const nuevo = {} as FlujoVentaPasoControl;
      nuevo.idFuncionalidadControl = this.fControl.idFuncionalidadControl.value;
      nuevo.indicadorBitacora = this.fControl.indicadorBitacora.value ? this.fControl.indicadorBitacora.value : false;
      const item = this.tabView.controles.find( x => x.idFuncionalidadControl === nuevo.idFuncionalidadControl );
      if ( item ) {
        nuevo.indicadorVisible = item.indicadorVisible;
        nuevo.indicadorHabilitado = true;
        nuevo.codigoFuncionalidadControl = item.codigo;
        nuevo.funcionalidadControl = item.nombre;
      }
      this.lisFlujoVentaControl = [ ...this.lisFlujoVentaControl, nuevo ];
      this.subControl = false;
      this.cargarControles();
      this.forControl.reset();
    }
  }

  buscarTabla() {
    setTimeout( () => {
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    }, 30 );
  }

  get f() {
    return this.formulario.controls;
  }

  get fControl() {
    return this.forControl.controls;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.invalid ) {
      scrollToFirstInvalidControl( this.formulario, this.flujoVentaFormRef.nativeElement );
    }
    if ( this.formulario.valid ) {
      this.conService.confirm( {
        message: this.navService.buscarMensaje( 'MSG_GUARDAR' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: `datos-basicos${ this.tabView.codigo }`,
        accept: () => {
          this.emitirCargando( true );
          if ( this.secFija || ( this.tabView.flujoVenta && this.tabView.flujoVenta.secuencia == this.f.secuencia.value ) ) {
            this.guardarSecuencia();
          } else {
            const valMovimiento = this.fluVentaPasoService.validarMovimiento( this.f.secuencia.value, this.tabView.flujoVenta ? this.tabView.flujoVenta.secuencia : null, this.lisPasos, this.tabView.codigo );
            if ( valMovimiento.estado ) {
              this.guardarSecuencia( true, this.f.secuencia.value, this.tabView.flujoVenta ? this.tabView.flujoVenta.secuencia : null );
            } else {
              this.navService.setMesage( 0, { severity: 'info', summary: 'Info', detail: valMovimiento.mensaje } );
              this.emitirCargando( false );
            }
          }
        },
        reject: () => {
        }
      } );
    }
  }

  emitirCargando( mensaje: boolean ) {
    this.communicationService.emitir( { canal: 'flujo-venta-cargando', mensaje: mensaje } );
  }

  notificar( actualizar: boolean, nuevoIndice: number, antiguoIndice: number, codigo: string ) {
    this.communicationService.emitir( {
      canal: 'flujo-venta-actualizo',
      mensaje: { actualizar: actualizar, nuevoIndice: nuevoIndice, antiguoIndice: antiguoIndice, codigo: codigo }
    } );
  }

  guardarSecuencia( notificar: boolean = false, nueIndice: number = null, antIndice: number = null ) {
    const registro = this.formulario.value;
    if ( registro.idFlujoVentaPaso ) {
      this.fluVentaPasoService.actualizar( registro ).subscribe( async r => {
        this.tabView.flujoVenta = registro;
        if ( notificar ) {
          this.notificar( true, nueIndice, antIndice, r.codigo );
        }
        this.validarTablasAdicionales( registro, 2 );
      } );
    } else {
      this.fluVentaPasoService.crear( registro ).subscribe( r => {
        this.f.idFlujoVentaPaso.setValue( r.idFlujoVentaPaso );
        registro.idFlujoVentaPaso = r.idFlujoVentaPaso;
        this.tabView.flujoVenta = registro;
        if ( notificar ) {
          this.notificar( false, nueIndice, antIndice, r.codigo );
        }
        this.validarTablasAdicionales( registro, 1 );
      } );
    }
  }

  validarTablasAdicionales( flujo: any, tipo: number ) {
    forkJoin( this.validarAdjuntos( flujo ), this.validarControles( flujo ),
      this.validarVinculaciones( flujo ), this.validarNaturaleza( flujo ), this.validarOcupaciones( flujo ) ).subscribe( r => {
      this.cargarListado();
      this.navService.setMesage( tipo );
      this.submitted = false;
      this.formulario.markAsPristine();
      this.emitirCargando( false );
      this.dismiss.emit( true );
    } );
  }

  async validarVinculaciones( flujo: any ) {
    const registros = [];
    flujo.vinculaciones.forEach( e => {
      const existe = this.lisFlujoVentaPasoVinculacion.find( x => x.idTipoVinculacion === e );
      console.log(existe);
      if ( existe && !existe.indicadorHabilitado ) {
        existe.indicadorHabilitado = true;
        registros.push( existe );
      } else if ( !existe ) {
        const a = {} as FlujoVentaPasoVinculacion;
        a.idTipoVinculacion = e;
        a.indicadorHabilitado = true;
        a.idFlujoVentaPaso = flujo.idFlujoVentaPaso;
        registros.push( a );
      }
    } );

    this.lisFlujoVentaPasoVinculacion.forEach( e => {
      if ( e.indicadorHabilitado && !flujo.vinculaciones.find( y => y === e.idTipoVinculacion ) ) {
        e.indicadorHabilitado = false;
        registros.push( e );
      }
    } );

    if ( registros.length > 0 ) {
      const resultado = await this.fluVentaPasoVinculacionService.bulk( registros ).toPromise();
      resultado.forEach( e => {
        const existe = this.lisFlujoVentaPasoVinculacion.find( x => x.idTipoVinculacion === e.idTipoVinculacion );
        if ( !existe ) {
          this.lisFlujoVentaPasoVinculacion.push( e );
        }
      } );
    }
    return true;
  }

  async validarNaturaleza( flujo: any ) {
    const lista = [];
    flujo.idsNaturaleza.forEach( e => {
      const _data = this.lisFlujoVentaPasoTiposPersonas.find( x => x.idTipoPersona === e );
      if ( _data && !_data.indicadorHabilitado ) {
        _data.indicadorHabilitado = true;
        lista.push( _data );
      } else {
        if (!_data) {
          const a = {} as FlujoVentaPasoTiposPersonas;
          a.idTipoPersona = e;
          a.indicadorHabilitado = true;
          a.idFlujoVentaPaso = flujo.idFlujoVentaPaso;
          lista.push( a );
        }

      }
    } );

    this.lisFlujoVentaPasoTiposPersonas.forEach( e => {
      if ( e.indicadorHabilitado && !flujo.idsNaturaleza.find( y => y === e.idTipoPersona ) ) {
        e.indicadorHabilitado = false;
        lista.push( e );
      }
    } );

    if ( lista.length > 0 ) {
      const resultado = await this.flujoVentaPasoTiposPersonas.bulk( lista ).toPromise();
      resultado.forEach( e => {
        const existe = this.lisFlujoVentaPasoTiposPersonas.find( x => x.idTipoPersona === e.idTipoPersona );
        if ( !existe ) {
          this.lisFlujoVentaPasoTiposPersonas.push( e );
        }
      } );
    }
    return true;
  }


  async validarOcupaciones( flujo: any ) {
    const lista = [];
    flujo.idsOcupacion.forEach( e => {
      const _data = this.lisFlujoVentaPasoOcupaciones.find( x => x.idTipoOcupacionConfiguracion === e );
      if ( _data && !_data.indicadorHabilitado ) {
        _data.indicadorHabilitado = true;
        lista.push( _data );
      } else if ( !_data ) {
        const a = {} as FlujoVentaPasoOcupacion;
        a.idTipoOcupacionConfiguracion = e;
        a.indicadorHabilitado = true;
        a.idFlujoVentaPaso = flujo.idFlujoVentaPaso;
        lista.push( a );
      }
    } );

    this.lisFlujoVentaPasoOcupaciones.forEach( e => {
      if ( e.indicadorHabilitado && !flujo.idsOcupacion.find( y => y === e.idTipoOcupacionConfiguracion ) ) {
        e.indicadorHabilitado = false;
        lista.push( e );
      }
    } );

    if ( lista.length > 0 ) {
      const resultado = await this.flujoVentaPasoOcupacionService.bulk( lista ).toPromise();
      resultado.forEach( e => {
        const existe = this.lisFlujoVentaPasoOcupaciones.find( x => x.idTipoOcupacionConfiguracion === e.idTipoOcupacionConfiguracion );
        if ( !existe ) {
          this.lisFlujoVentaPasoOcupaciones.push( e );
        }
      } );
    }
    return true;
  }

  async validarAdjuntos( flujo: any ) {
    if ( flujo.idAdjunto && ( !this.fluVentaAdjunto || this.fluVentaAdjunto.idAdjunto !== flujo.idAdjunto ) ) {
      const registro = this.fluVentaAdjunto ? this.fluVentaAdjunto : {} as FlujoVentaPasoAdjunto;
      registro.indicadorHabilitado = true;
      registro.idFlujoVentaPaso = flujo.idFlujoVentaPaso;
      registro.idAdjunto = flujo.idAdjunto;
      this.fluVentaAdjunto = await ( registro.idFlujoVentaPasoAdjunto ? this.fluVentaPasoAdjuntoService.actualizar( registro ) : this.fluVentaPasoAdjuntoService.crear( registro ) ).toPromise();
      this.fluVentaAdjunto.nombreArchivo = this.nomArchivo;
      this.adjunto = this.adjTemporal;
    } else if ( !flujo.idAdjunto && this.fluVentaAdjunto && this.fluVentaAdjunto.indicadorHabilitado ) {
      this.fluVentaAdjunto.indicadorHabilitado = false;
      await this.fluVentaPasoAdjuntoService.actualizar( this.fluVentaAdjunto ).toPromise();
    }
    return true;
  }

  async validarControles( flujo: any ) {
    const registros = [];
    console.log(this.lisFlujoVentaControl);
    this.lisFlujoVentaControl.forEach( e => {
      const existe = this.lisFlujoVentaControlTodos.find( x => x.idFuncionalidadControl === e.idFuncionalidadControl );
      if ( existe) {
        existe.indicadorHabilitado = true;
        registros.push( existe );
      } else if ( !existe ) {
        e.idFlujoVentaPaso = flujo.idFlujoVentaPaso;
        this.lisFlujoVentaControlTodos.push( e );
        registros.push( e );
      }
    } );

    this.lisFlujoVentaControlTodos.forEach( e => {
      if ( e.indicadorHabilitado && !this.lisFlujoVentaControl.find( y => e.idFuncionalidadControl === y.idFuncionalidadControl ) ) {
        e.indicadorHabilitado = false;
        registros.push( e );
      }
    } );

    if ( registros.length > 0 ) {
      console.log(registros);
      const resultado = await this.fluVentaPasoControlService.bulk( registros ).toPromise();
      resultado.forEach( e => {
        const valor = this.lisFlujoVentaControlTodos.find( x => x.idFuncionalidadControl === e.idFuncionalidadControl && !x.idFlujoVentaPasoControl );
        if ( valor ) {
          valor.idFlujoVentaPasoControl = e.idFlujoVentaPasoControl;
        }
      } );
    }
    return true;
  }

  validarArreglos(): boolean {
    const habilitados = this.lisFlujoVentaControlTodos.filter( x => x.indicadorHabilitado );
    if ( habilitados.length !== this.lisFlujoVentaControl.length ) {
      return true;
    }
    const b = [ ...this.lisFlujoVentaControl ].sort( ( a, x ) => {
      return a.id - x.id;
    } );
    habilitados.sort( ( x, y ) => {
      return x.id - y.id;
    } );
    return !!habilitados.find( ( x, y ) => x.idFuncionalidadControl !== b[ y ].idFuncionalidadControl );
  }


  regresar( dirty: boolean ) {
    if ( dirty || this.validarArreglos() ) {
      this.conService.confirm( {
        message: this.navService.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: `datos-basicos${ this.tabView.codigo }`,
        accept: () => {
          this.reiniciar();
        },
        reject: () => {
        }
      } );
    } else {
      this.reiniciar();
    }
  }

  reiniciar() {
    this.cargando = true;
    this.submitted = false;
    this.cargarFormulario();
    this.formulario.markAsPristine();
    this.cargarListado();
    this.cargarControles();
    this.cargarFormularioControl();
    this.nomArchivo = null;
    this.imagen = null;
    this.carImagen = false;
    if ( this.fluVentaAdjunto && this.fluVentaAdjunto.indicadorHabilitado ) {
      this.cargarReaderImagen( this.adjunto );
      this.nomArchivo = this.fluVentaAdjunto.nombreArchivo;
    }
    this.subControl = false;
    this.forControl.markAsPristine();
    setTimeout( () => {
      this.cargando = false;
      this.buscarTabla();
    }, 30 );
  }

  onBeforeSend( event: any ) {
    this.carImagen = true;
    this.adjService.cargarArchivo( event, this.nomArchivo, 'Flujo venta' );
  }

  onUpload( event: any ) {
    const respuesta = event.originalEvent.body
    if ( respuesta.idAdjunto ) {
      this.f.idAdjunto.setValue( respuesta.idAdjunto );
      this.f.idAdjunto.markAsDirty();
      this.carImagen = false;
    }
  }

  onSelect( event: any, file: any ) {
    this.nomArchivo = file[ 0 ].name;
    this.adjTemporal = file[ 0 ];
    this.cargarReaderImagen( file[ 0 ] );
  }

  cargarReaderImagen( file: any ) {
    const reader = new FileReader();
    reader.addEventListener( 'load', () => {
      this.imagen = this.sanitizer.bypassSecurityTrustUrl( reader.result.toString() );
    }, false );
    if ( file ) {
      reader.readAsDataURL( file );
    }
  }

  cargarAdjunto( fluAdjunto: FlujoVentaPasoAdjunto ) {
    this.carImagen = true;
    this.adjService.descargarArchivo( fluAdjunto.idAdjunto ).subscribe( adjunto => {
      this.nomArchivo = fluAdjunto.nombreArchivo;
      this.adjunto = adjunto;
      this.cargarReaderImagen( adjunto );
      this.carImagen = false;
    }, error => {
      this.carImagen = false;
    } );
  }

  cancelarAdjunto() {
    this.f.idAdjunto.setValue( null );
    this.f.idAdjunto.markAsDirty();
    this.imagen = null;
  }

  quitarControl( elemento: FlujoVentaPasoControl ) {
    this.conService.confirm( {
      message: this.navService.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: `datos-basicos${ this.tabView.codigo }`,
      accept: () => {
        const indice = this.lisFlujoVentaControl.findIndex( x => x.idFuncionalidadControl === elemento.idFuncionalidadControl );
        if ( indice >= 0 ) {
          const pagina = this.tabla.first > 0 ? ( this.tabla.first / 10 ) + 1 : 1;
          this.lisFlujoVentaControl.splice( indice, 1 );
          this.lisFlujoVentaControl = [ ...this.lisFlujoVentaControl ];
          this.cargarControles();
          setTimeout( () => {
            const canPagina = this.tabla.totalRecords > 0 ? ( Math.floor( ( this.tabla.totalRecords - 1 ) / 10 ) ) + 1 : 1;
            if ( pagina > canPagina ) {
              this.tabla.first = pagina > 1 ? ( pagina - 2 ) * 10 : 0;
            }
          }, 5 );
        }
      },
      reject: () => {
      }
    } );
  }

  verRoles( elemento: FlujoVentaPasoControl ) {
    this.carTabla = true;
    this.rolFuncionalidadControlService.getByIdFuncionalidadControlEnabled( elemento.idFuncionalidadControl ).subscribe( lis => {
      this.carTabla = false;
      if ( lis.length === 0 ) {
        this.navService.setMesage( 0, {
          severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navService.buscarMensaje( 'FLUJOVENTA.MSG_NOEXISTEROLCONF' )
        } );
        return;
      }
      this.mosModalRoles = true;
      this.objControlSeleccionado = elemento;
      this.lisRoles = lis;
    } );
  }

  cerrarRoles() {
    this.mosModalRoles = false;
  }

  ngOnDestroy(): void {
    if ( this.subscription ) {
      this.subscription.unsubscribe();
    }
  }


}
